<template>
  <router-view />
</template>

<script>
import { mapActions, mapGetters } from "vuex"; 
export default {
  name: "exhibition-template",
  data() {
    return {
      bodyHeight: "800px",
      siderArr: [
        {
          title: "Home",
          icon: "icon-shouye11",
          router: "/exhibitionEn/index/home",
          type: 1
        },
        // {
        //   title: "订单中心",
        //   icon: "icon-dingdanzhongxin",
        //   router: "/exhibition/index/order",
        //   type: 1
        // },
        // {
        //   title: "图集管理",
        //   icon: "icon-sucaiku1",
        //   router: "/exhibition/index/photo",
        //   type: 1
        // },
        {
          title: "Exhibiting Information",
          icon: "icon-diamonds",
          type: 2,
          children: [
            {
              title: "主页设置",
              router: "/exhibitionEn/index/template"
            },
            // {
            //   title: "我的展位图",
            //   router: "/exhibition/index/exinfo/boothImg"
            // },
            {
              title: "Show Catalogue",
              router: "/exhibitionEn/index/exinfo/catalogue"
            },
            {
              title: "Fascia (Shell Scheme Only)",
              router: "/exhibitionEn/index/exinfo/fascia-board"
            },
            {
              title: "车证申请",
              router: "/exhibitionEn/index/exinfo/carApply"
            }
          ]
        },
        // {
        //   title: "推广",
        //   icon: "icon-yijicaidanalituku_tuiguang",
        //   type: 2,
        //   children: [
        //     {
        //       title: "商机",
        //       router: "/exhibition/index/business"
        //     },
        //     {
        //       title: "商机",
        //       router: "/exhibition/index/release"
        //     },
        //     {
        //       title: "供需",
        //       router: "/exhibition/index/release-new"
        //     },
        //     {
        //       title: "动态",
        //       router: "/exhibition/index/moment"
        //     },
        //   ]
        // },
        {
          title: "My Cloud Booth",
          icon: "icon-guanli",
          type: 2,
          children: [
            {
              title: "产品",
              router: "/exhibitionEn/index/product"
            },
            {
              title: "活动",
              router: "/exhibitionEn/index/activity"
            },
            // {
            //   title: "人员",
            //   router: "/exhibition/index/companyAdmin"
            // },
            {
              title: "案例",
              router: "/exhibitionEn/index/case"
            },
            {
              title: "品牌",
              router: "/exhibitionEn/index/brand"
            },
            {
              title: "合作医院",
              router: "/exhibitionEn/index/partner"
            },
            {
              title: "资质证书",
              router: "/exhibitionEn/index/certificate"
            },
            {
              title: "素材库",
              router: "/exhibitionEn/index/material"
            }
          ]
        },
        {
          title: "Exhibition Center",
          icon: "icon-peizhi1",
          type: 2,
          children: [
            {
              title: "公司信息",
              router: "/exhibitionEn/index/companyInfo"
            },
            // {
            //   title: "管理员资料",
            //   router: "/exhibition/index/companyAdmin"
            // },
            {
              title: "产品展示组",
              router: "/exhibitionEn/index/proGroup/productlist"
            },
            // {
            //   title: "分享设置",
            //   router: "/exhibition/index/share"
            // },
            {
              title: "账户安全",
              router: "/exhibitionEn/index/companyAccount"
            }
          ]
        }
      ],
      templateData: null
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: 1000,
        PageIndex: 1
      };
    }
  },
  updated() {
    this.init();
  },
  async created() { 
    document.title = "中国国际医疗器械博览会 - Settings";
    this.init();
  },
  methods: {
    ...mapActions({
      putJoinExhibitionInfo: "exhibitionModule/putJoinExhibitionInfo",
      joinExhibition: "exhibitionModule/joinExhibition",
      getByCompany: "exhibitionModule/getByCompany",
      getJoinById: "exhibitionModule/getJoinById"
    }),
    async init() {
      this.$router.push(
        `/exhibitionEn/index/template/service?origin=2&editId=${this.joinInfo.joinId}`
      );
    }
  }
};
</script>

<style scoped lang="scss">
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.side-logo {
  height: 64px;
  background-color: #fff;
  padding-top: 13px;
  padding-left: 24px;
}
</style>
